<script>
import EventBus from '@/utils/event-bus';

export default {
  name: 'ScrollToTop',
  mounted() {
    EventBus.$emit('reset-scroll');
  },

};
</script>
